export interface GetConvertShelfTypeRequest {
  branchCode: string
}

export function GetConvertShelfTypeRequestToJSON(
  value: GetConvertShelfTypeRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined
  }
}
